import React, { useState } from "react";
import { Tabs } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import Icon from "../icon";
import "../../output.css";
import servicesData from "../../data/servicesData";
import { CustomSelect, PassengerDropdown, FlightForm } from "./index";
import fetchOffersQuery from "../../queries/fetchOffers";
import { getSlices } from "../../helpers/flights";
import { Container, styled, Button } from "@mui/material";
import { colors } from "../../configs";

const StyledButton = styled(Button)({
  backgroundColor: colors.main,
  color: "#FFFFFF",
  "&: hover": {
    backgroundColor: colors.main,
    color: "#FFFFFF",
  },
});
const OptionsButton = styled(Button)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#FFFFFF",
  padding: "10px 15px",
  borderRadius: "15px",
  marginRight: "5px",
  textTransform: "capitalize",
});
const travelsList = [
  {
    leavingFrom: "",
    goingTo: "",
    departureDate: null,
    returnDate: null,
  },
];

const Services = ({
  noStop,
  checkedLugageIn,
  moreLessDay,
  stopLessThree,
}: any) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("flight");
  const [trip, setTrip] = useState("Round-trip");
  const [flightClass, setFlightClass] = useState("Economy");
  const [travels, setTravels] = useState(travelsList);
  const [isFetching, setIsFetching] = useState(false);
  const [travelIdx, setTravelIdx] = useState(0);

  const [passengers, setPassengers] = useState<any[]>([
    {
      label: "Adults",
      caption: "Ages 18 or above",
      count: 1,
      age: 20,
      type: "adult",
    },
    {
      label: "Children",
      caption: "Ages 2-18",
      count: 0,
      age: 17,
      type: "child",
    },
    {
      label: "Infants",
      caption: "under 2",
      count: 0,
      age: 1,
      type: "infant_without_seat",
    },
  ]);
  const initialDepature = new Date();
  const initialReturning = new Date();
  //    initialReturning.setDate(initialReturning.getDate() + 1);

  const getOfferQuery = () => {
    const getCabinClass = (cl: string) => {
      if (cl === "FIRST") {
        return "first";
      } else if (cl === "BUSINESS") {
        return "business";
      } else if (cl === "PREMIUM ECONOMY") {
        return "premium_economy";
      } else {
        return "economy";
      }
    };
    // réecriture de la fonction de conversion de la liste des passagers...
    const passList: any[] = [];
    passengers.map((passCategory: any, idx) => {
      if (passCategory.count > 0) {
        for (let index = 0; index < passCategory.count; index++) {
          passList.push({
            type: passCategory.type,
          });
        }
      }
    });

    return {
      live_mode: false,
      return_offers: false,
      supplier_timeout: 0,
      cabin_class: getCabinClass(flightClass.toUpperCase()),
      max_connections: 1,
      passengers: passList,
    };
  };

  const fetchOffers = async () => {
    // const isSlicesReady = () => travels[0].leavingFrom !== "" && travels[0].goingTo !== "";
    const isSlicesReady = () => true; // used for debugging, should be readapted

    if (isSlicesReady()) {
      setIsFetching(true);
      console.log("Fetching Normal Travel Data");

      console.log("Trip: ", trip);
      console.log("Travels: ", travels);

      let query = getOfferQuery();
      let slices: any[] = getSlices(
        trip,
        travels,
        initialDepature,
        initialReturning
      );

      console.warn("slice in services: ", slices);
      let buildedQuery = { ...query, slices: [{ ...slices[0] }] };

      console.warn("BUILD QUERY ", buildedQuery);

      navigate("flights/0", {
        state: {
          query: query,
          slices: slices,
          slice_index: 0,
          noStop: noStop,
          checkedLugageIn: checkedLugageIn,
          moreLessDay: moreLessDay,
          stopLessThree: stopLessThree,
          selectedOffers: [],
          trip: trip,
          fClass: flightClass,
        },
      });
    } else {
      console.log(" slice not ready yet");
    }
  };

  const addTravel = () => {
    const newTravels = travels.concat({
      leavingFrom: "",
      goingTo: "",
      departureDate: null,
      returnDate: null,
    });
    console.log("THE CONCATED TRAVEL: ", newTravels);
    setTravelIdx(travelIdx + 1);
    setTravels(newTravels);
  };

  return (
    <Container
      sx={{
        backgroundColor: "#FFFFFF",
        padding: "20px",
        marginTop: "50px",
        borderRadius: "10px",
        minWidth: "1000px",
        width: "1000px",
        display: "flex",
      }}>
      <Tabs
        value={activeTab}
        onTabChange={(tab: any) => {
          setActiveTab(tab);
        }}>
        <Tabs.List className="w-[100%] border-b border-gray-200">
          {servicesData.map((data, i) => (
            <Tabs.Tab
              key={i}
              value={data.value}
              pb="lg"
              icon={
                <Icon
                  icon={data.icon}
                  color={activeTab === data.value ? "black" : "gray"}
                  height={data.height}
                  className={undefined}
                />
              }
              px={0}
              mr="lg">
              <p
                className={`font-bold text-xs ${
                  activeTab === data.value ? "text-gray-800" : "text-gray-500"
                }`}>
                {data.title}
              </p>
            </Tabs.Tab>
          ))}
          {activeTab === "flight" ? (
            <div className="flex flex-wrap ml-auto gap-x-4">
              <CustomSelect
                options={["One-way", "Round-trip", "Multi-City"]}
                defaultValue={trip}
                style={{
                  input: {
                    fontWeight: 500,
                    color: "#605858",
                    width: "118px",
                  },
                }}
                onChange={setTrip}
                placeholder={undefined}
                label={undefined}
              />
              <PassengerDropdown
                items={passengers}
                setPassengers={setPassengers}
              />
              <CustomSelect
                options={["Economy", "Premium Economy", "Business", "First"]}
                defaultValue={flightClass}
                style={{
                  input: {
                    fontWeight: 500,
                    color: "#605858",
                    width: "148px",
                  },
                }}
                onChange={setFlightClass}
                placeholder={undefined}
                label={undefined}
              />
            </div>
          ) : null}
        </Tabs.List>
        <Tabs.Panel value="flight" pt="sm">
          <div className="md:grid md:grid-cols-12">
            <div className="md:col-span-10">
              {travels.map((t, i) => (
                <FlightForm
                  key={i}
                  index={i}
                  leavingFrom={t.leavingFrom}
                  goingTo={t.goingTo}
                  travels={travels}
                  setTravels={setTravels}
                  trip={trip}
                  departureDate={t.departureDate ? t.departureDate : null}
                  returnDate={t.returnDate ? t.returnDate : null}
                  travelIndex={travelIdx}
                />
              ))}
              {trip === "Multi-City" ? (
                <div className="flex justify-start mt-1">
                  <StyledButton onClick={() => addTravel()}>Add</StyledButton>
                </div>
              ) : null}
            </div>
            <div className="md:flex md:justify-center items-end md:col-span-2">
              <StyledButton
                onClick={fetchOffers}
                disabled={isFetching}
                style={{
                  height: "52px",
                  maxHeight: "52px",
                  width: "90%",
                }}>
                {isFetching ? "Searching..." : "Search"}
              </StyledButton>
            </div>
          </div>
        </Tabs.Panel>
        <Tabs.Panel value="hotel" pt="sm">
          <div>Booking hotel is coming soon</div>
        </Tabs.Panel>
        <Tabs.Panel value="car" pt="sm">
          <div>Rent a car is coming soon</div>
        </Tabs.Panel>
        <Tabs.Panel value="visa" pt="sm">
          <div>Visa is coming soon</div>
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default Services;
